module.exports = __webpack_public_path__ + "static/media/landing-mockup.e1eddcea.png";